import { useState, useEffect } from "react";
import { X } from "lucide-react";
import HeroSection from "../components/HeroSection";
import StatsBar from "../components/StatsBar";
import AboutFirm from "../components/AboutFirm";
import PracticeAreas from "../components/PracticeAreas";
import EnquiryForm from "../components/EnquiryForm";

export default function Home() {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Show modal after a short delay when component mounts
    const timer = setTimeout(() => {
      setShowModal(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Prevent body scroll when modal is open
    if (showModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [showModal]);

  return (
    <>
      <HeroSection />
      <StatsBar />
      <AboutFirm />
      <PracticeAreas />

      {/* ================= ENQUIRY FORM MODAL ================= */}
      {showModal && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
          onClick={() => setShowModal(false)}
        >
          <div
            className="relative w-full max-w-lg max-h-[90vh] overflow-y-auto
                       bg-white rounded-lg shadow-2xl
                       animate-in fade-in zoom-in duration-300"
            onClick={(e) => e.stopPropagation()}
          >
            {/* CLOSE BUTTON */}
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-4 right-4 z-10
                         p-2 rounded-full
                         bg-gray-100 hover:bg-gray-200
                         text-gray-600 hover:text-gray-900
                         transition-all duration-200
                         hover:scale-110"
              aria-label="Close modal"
            >
              <X size={24} strokeWidth={2.5} />
            </button>

            {/* ENQUIRY FORM */}
            <div className="px-6 py-8">
              <EnquiryForm />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
